import { getServiceRequestDrafts } from '@/sdk/clients/ServicesRequest'
import { Mutations } from '@/store/booking-funnel/carereceiver/types'

const logger = require('debug')('careship:store/status')

const userHasNoDrafts = response => !response.length

const draftHasCareReceiver = draft =>
  Object.prototype.hasOwnProperty.call(draft, 'care_receiver_id')

export default {
  // @TODO: break checkCustomerStatus into pieces [reason: it's doing too many things]
  async checkCustomerStatus({ commit, dispatch, rootGetters }) {
    logger('store.action -> checkCustomerStatus')

    const response = await getServiceRequestDrafts()

    if (userHasNoDrafts(response)) {
      return
    }

    const currentDraft = response[0]

    if (draftHasCareReceiver(currentDraft)) {
      dispatch(
        'carereceiver/setCareReceiverIdForCurrentBookingFunnel',
        currentDraft.care_receiver_id,
        { root: true },
      )
    }

    commit('registration/setServiceRequestDraftId', currentDraft.process_id, {
      root: true,
    })
    commit('serviceRequestDraft', currentDraft)

    if (currentDraft.post_code) {
      dispatch('postcode/setPostcode', currentDraft.post_code.post_code, {
        root: true,
      })
    }

    if (currentDraft.service) {
      const {
        gender_preference,
        other_services,
        services,
      } = currentDraft.service

      dispatch(
        'services/setServicePageData',
        {
          genderPreference: gender_preference,
          otherServices: other_services,
          services,
        },
        {
          root: true,
        },
      )
    }

    const activeCarePlans = rootGetters['definitions/activeCarePlans']

    if (
      currentDraft.care_plan &&
      activeCarePlans.some(
        carePlan => carePlan.id === currentDraft.care_plan.id,
      )
    ) {
      dispatch('services/setCarePlan', currentDraft.care_plan.id, {
        root: true,
      })
    } else {
      dispatch('services/setCarePlan', 'NEW_no_plan_Germany', {
        root: true,
      })
    }

    if (currentDraft.care_receiver) {
      commit(
        `carereceiver/${Mutations.SET_CARERECEIVER_FROM_BE}`,
        currentDraft.care_receiver,
        { root: true },
      )
    }

    if (currentDraft.scheduling) {
      commit('scheduling/setSchedulingFromBE', currentDraft.scheduling, {
        root: true,
      })
    }

    if (currentDraft.payment) {
      dispatch('payment/setPaymentFromBE', currentDraft.payment, { root: true })
    }
  },

  async getServiceRequestDraft({ commit }) {
    logger('store.action -> getServiceRequestDraft')
    const drafts = await getServiceRequestDrafts()

    if (drafts.length > 0) {
      logger(
        'store.action -> getServiceRequestDraft -> found drafts %O',
        drafts,
      )
      commit('serviceRequestDraft', drafts[0])

      // grab the postcode and save it in registration
      const postcode =
        (drafts[0].post_code && drafts[0].post_code.post_code) ||
        (drafts[0].care_receiver &&
          drafts[0].care_receiver.address &&
          drafts[0].care_receiver.address.postal_code)

      if (postcode) {
        commit('postcode/setPostcode', postcode, { root: true })
      }
    } else {
      logger('store.action -> getServiceRequestDraft -> no draft found')
    }
  },
}
